/* Utils */
import { generateSelectEntityById, generateSelectEntitiesByIdsList } from '../utils/generators/selectorGenerators';

export const selectAllSeasons = (state) => state.seasons;

export const selectSeasonById = generateSelectEntityById(selectAllSeasons);

export const selectSeasonsListByIdsList = generateSelectEntitiesByIdsList(selectAllSeasons);
